import { combineReducers } from 'redux';

import websocketReducer from './features/gameState/store/websocketSlice';

export type ApplicationState = {
  features: {
    websocket : ReturnType<typeof websocketReducer>;
  };
};

const createRootReducer = () =>
  combineReducers({
    features: combineReducers({
      websocket: websocketReducer,
    }),
  });

export default createRootReducer;
